export default "__VITE_ASSET__DH6dmpHp__"